import { render, staticRenderFns } from "./RECALL_BASE.vue?vue&type=template&id=1c4af840&scoped=true"
import script from "./RECALL_BASE.vue?vue&type=script&lang=js"
export * from "./RECALL_BASE.vue?vue&type=script&lang=js"
import style0 from "./RECALL_BASE.vue?vue&type=style&index=0&id=1c4af840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4af840",
  null
  
)

export default component.exports